import React, { useState, useEffect } from 'react';
import api from '../utils/axiosInstance';
import { Input, Textarea, Button } from './ui';
import { useModal } from '../context/ModalContext';

export default function MessageForm() {
  const modal = useModal();
  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    sessionId: '',
    phoneNumber: '',
    message: '',
  });

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await api.get('/api/sessions');
        // backend: { success: true, data: [...] }
        const data = res?.data?.data ?? [];
        const connected = data.filter(c => c.status === 'connected');
        setClients(connected);
        if (connected.length > 0) {
          setFormData(f => ({ ...f, sessionId: connected[0].sessionId }));
        }
      } catch (err) {
        console.error('Failed to fetch sessions', err);
        setClients([]);
      }
    };
    fetchClients();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSend = async () => {
    if (!formData.sessionId || !formData.phoneNumber || !formData.message) {
      modal.alert('Please fill all fields', 'warning');
      return;
    }
    try {
      await api.post(
        `/api/whatsapp/${formData.sessionId}/send`,
        {
          number: formData.phoneNumber,
          message: formData.message,
        }
      );
      modal.alert('Message sent successfully', 'success');
    } catch (err) {
      console.error('Send message error', err);
      modal.alert('Failed to send message', 'error');
    }
  };

  return (
    <div className="space-y-4">
      <div className="input-group">
        <label className="input-label">WhatsApp Client</label>
        <select
          name="sessionId"
          value={formData.sessionId}
          onChange={handleChange}
          className="input"
        >
          {clients.map(client => (
            <option key={client.sessionId} value={client.sessionId}>
              {client.number
                ? `${client.number} (${client.sessionId})`
                : client.sessionId}
            </option>
          ))}
        </select>
      </div>

      <div className="input-group">
        <label className="input-label">Phone Number (With Country Code)</label>
        <Input
          type="text"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          placeholder="+919999999999"
        />
      </div>

      <div className="input-group">
        <label className="input-label">Message</label>
        <Textarea
          name="message"
          rows={2}
          value={formData.message}
          onChange={handleChange}
        />
      </div>

      <Button variant="primary" className="w-full" onClick={handleSend}>Send</Button>
    </div>
  );
}
